import React from 'react';
import { useIntl } from 'react-intl';

import { FontSizePropKey } from 'app/shared/theme';
import {
  SOFAR_PRIVACY_POLICY_URL,
  SOFAR_TERMS_AND_CONDITIONS_URL,
} from 'app/shared/utils/siteUrls';
import { NavigationLink, Typography } from 'app/shared/components/atoms';

interface TermsAndConditionsProps {
  color?: string;
  fontSize?: FontSizePropKey;
  linkVariant?: 'primary' | 'secondary' | 'tertiary';
}

export const TermsAndConditions = ({
  color,
  fontSize = 'fontSize75',
  linkVariant = 'secondary',
}: TermsAndConditionsProps) => {
  const { formatMessage } = useIntl();

  return (
    <Typography fontSize={fontSize} color={color}>
      {formatMessage({ id: 'termsAndConditions.intro' })}
      <NavigationLink
        data-qaid="terms-and-conditions"
        href={SOFAR_TERMS_AND_CONDITIONS_URL}
        fontWeight="regular"
        fontSize={fontSize}
        openInNewTab={true}
        textDecoration="underline !important"
        variant={linkVariant}
      >
        {formatMessage({
          id: 'shared.termsOfService',
        })}
      </NavigationLink>
      {formatMessage({ id: 'shared.termsAndConditions.midfix' })}
      <NavigationLink
        data-qaid="privacy-policy"
        href={SOFAR_PRIVACY_POLICY_URL}
        fontWeight="regular"
        fontSize={fontSize}
        openInNewTab={true}
        textDecoration="underline !important"
        variant={linkVariant}
      >
        {formatMessage({ id: 'shared.privacyPolicy' })}
      </NavigationLink>
      .
    </Typography>
  );
};
